import type { Selection } from "react-aria-components";

export const ALL_CYCLES_ID = "all-cycles";

export function toSelectedKeys(selectedIds: string[], isWholeHistory: boolean): string[] {
    if (selectedIds.length > 0) {
        return selectedIds;
    }

    return isWholeHistory ? [ALL_CYCLES_ID] : [];
}

export function resolveCycleSelection(keys: Selection, selectedIds: string[]): string[] {
    if (keys === "all") {
        return [];
    }

    const next = [...keys].map(String);

    if (next.includes(ALL_CYCLES_ID) && selectedIds.length > 0) {
        return [];
    }

    return next.filter(id => id !== ALL_CYCLES_ID);
}
